export default "__VITE_ASSET__CdklxhYQ__"